import { cloneDeep } from 'lodash-es';
import {Injectable} from '@angular/core';
import { HttpClient } from "@angular/common/http";
import {Observable, throwError} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {BillingLine} from "../../models/billing-line/billing-line.model";

@Injectable({
    providedIn: 'root',
})
export class CustomerContractService {
    API_URL = '/apiCustomerContract/v1/customer-contract';

    constructor(private http: HttpClient) {
    }

    getCustomerContractsByContractId(contractId: string): Observable<BillingLine[]> {
        return this.http.get<any[]>(`${this.API_URL}/${contractId}`).pipe(
            map(data => BillingLine.fromJsonArray(data)),
            catchError(err => {
                console.error('Erreur lors de la récupération des contrats client LMS :', err);
                err.error && console.log("ERREUR LMS :",err.error);
                return throwError(() => err);
            }) 
        );
    }

    filterCustomerContractsByServiceCode(customerContracts: BillingLine[], serviceCode: String): BillingLine[] {
        return customerContracts != null && customerContracts.filter(cc => serviceCode === cc.servicePricing);
    }

    aggregateCustomerContractsByServiceCode(customerContractsByServiceCode: BillingLine[], groupByKeys: (keyof BillingLine)[]): BillingLine[] {
        let customerContractMap = new Map<string, BillingLine[]>();

        customerContractsByServiceCode.forEach(customerContract => {
            const key = groupByKeys.map(key => customerContract[key]).join('|');

            if(customerContractMap.get(key)) {
                customerContractMap.get(key).push(customerContract);
            } else {
                customerContractMap.set(key, []);
                customerContractMap.get(key).push(customerContract);
            }
        });

        let aggregatedCustomerContractsByServiceCode: BillingLine[] = [];

        const values:any = Array.from(customerContractMap.values());

        values.forEach(element => {
            let customerContract =  cloneDeep(element[0]);
            customerContract.weeklyQuantity = element.reduce((sum, item) => sum + item.weeklyQuantity, 0);
            customerContract.weeklyAmount = customerContract.weeklyQuantity * customerContract.unitPrice;
            customerContract.monthlyQuantity = element.reduce((sum, item) => sum + item.monthlyQuantity, 0);
            customerContract.monthlyAmount = customerContract.monthlyQuantity * customerContract.unitPrice;
            customerContract.consumptionAllowance = element.reduce((max, item) => {
                // Skip empty strings or invalid numbers
                const currentQuantity = item.consumptionAllowance?.trim();
                if (currentQuantity === '' || isNaN(parseInt(currentQuantity, 10))) return max;

                // Compare as numbers
                return Math.max(Number(max), Number(currentQuantity)).toString();
            }, '');

            aggregatedCustomerContractsByServiceCode.push(customerContract);
        });

        return aggregatedCustomerContractsByServiceCode;
    }

    groupCustomerContractsByServiceCode(customerContracts: BillingLine[]): Record<string, BillingLine[]> {
        return customerContracts.reduce(
            (record: Record<string, BillingLine[]>, cc: BillingLine) => {
                const key = cc.servicePricing;
                if (!record[key]) {
                    record[key] = [];
                }
                record[key].push(cc);
                return record;
            },
            {} as Record<string, BillingLine[]>
        );
    }
    
    
    

}
